import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import useAuth from '../../../../../hooks/useAuth';
import { BodyThree } from '../../../../../styles/theme/default/typography';
import Icon from '../../../../Icon';
import MenuItem from './MenuItem';

const Wrapper = styled.ul`
  padding: 15px;

  list-style: none;
  &:focus {
    outline: none;
  }

  .line {
    width: 30px;
    margin: 15px 0px !important;
    height: 0px !important;
    border-bottom: 1px solid #767676;
  }

  .need-help,
  .menu-list-item {
    height: 48px;
  }

  .menu-list-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.charcoal};

    a {
      color: ${({ theme }) => theme.colors.charcoal};
      &:hover {
        color: ${({ theme }) => theme.colors.charcoal};
        text-decoration: none;
      }
    }
  }
`;

function MenuList({ className, setSelected }) {
  const user = useSelector(state => state.Auth.user);
  const history = useHistory();
  const [login, logout, { loading, error, data, isAuthenticated }] = useAuth();

  const handleLogout = () => {
    logout();
    history.push(`/`);
  };
  return (
    <Wrapper className={className}>
      <MenuItem color="A83569" name="New" onClick={() => setSelected('new')} />
      <MenuItem name="Bedroom" onClick={() => setSelected('bedroom')} />
      <MenuItem name="Living" onClick={() => setSelected('living')} />
      <MenuItem name="Dining" onClick={() => setSelected('dining')} />
      <MenuItem name="Office" onClick={() => setSelected('office')} />
      <MenuItem name="Decor" onClick={() => setSelected('decor')} />
      <MenuItem name="Outdoor" onClick={() => setSelected('outdoor')} />
      <MenuItem name="Gifts" onClick={() => setSelected('gifts')} />
      <MenuItem name="Inspiration" onClick={() => setSelected('inspiration')} />
      <div className="line" />
      <MenuItem
        name="Collaborations"
        onClick={() => setSelected('collaborations')}
      />

      {/* <MenuItem name="House Tours" onClick={() => setSelected('houseTours')} /> */}

      <MenuItem name="Swatches" onClick={() => setSelected('swatches')} />
      <MenuItemLink name="Design Services" to="/design-services" />

      <div className="line" />
      <li className="menu-list-item">
        {isAuthenticated ? (
          <Link to="/account">My Account</Link>
        ) : (
          <Link to="/login">Login / Sign Up</Link>
        )}
      </li>
      {isAuthenticated && (
        <li className="menu-list-item">
          <BodyThree as="a" href="#" onClick={handleLogout}>
            Logout
          </BodyThree>
        </li>
      )}
      <li
        id="extole_zone_mobile_menu"
        className="menu-list-item give50"
        href="#"
      />
      <MenuItemLink name="Trade" to="/design-trade-services" />
      <MenuItemLink name="Reviews" to="/reviews" />
      <MenuItemLink name="Contact" to="/contact" />
      <MenuItemLink name="Gift Cards" to="/gift-cards" />
      <div className="line" />
      <li className="need-help">
        <BodyThree>Need help?</BodyThree>
        {/* <BodyFive color="#6C6C6C">Mon-Fri, 9am-5pm EST</BodyFive> */}
      </li>
      {/* <ContactMenuItem
        logoName="fas fa-phone-alt"
        title="Call or Text"
        info="860-603-3878"
        url="tel:+1860-603-3878"
      /> */}

      <ContactMenuItem
        logo={<Icon icon="ti-email" size={20} color="black" />}
        title="Email"
        info="hi@theinside.com"
        url="mailto:hi@theinside.com"
      />
    </Wrapper>
  );
}

export default MenuList;

const WrapperMenuItemLink = styled.li`
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon {
    margin-left: 5px;
  }

  a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    &:hover {
      text-decoration: none;
    }
  }
`;

export const MenuItemLink = ({ name, to, external }) => {
  if (external) {
    return (
      <WrapperMenuItemLink>
        <a href={to} rel="noopener" target="_blank" className="body-two">
          <BodyThree className="body-two">{name}</BodyThree>{' '}
          <Icon className="icon" icon="ti-new-tab" size="18" color="black" />
        </a>
      </WrapperMenuItemLink>
    );
  }

  return (
    <WrapperMenuItemLink>
      <Link to={to}>
        <BodyThree className="body-two">{name}</BodyThree>
      </Link>
    </WrapperMenuItemLink>
  );
};

const WrapperContactMenuItem = styled.li`
  height: 48px;
  display: flex;
  align-items: center;
  .logo-container {
    margin-right: 15px;
  }
  i {
    font-size: 20px;
  }
  a {
    color: ${({ theme }) => theme.colors.charcoal};
    &:hover {
      color: ${({ theme }) => theme.colors.charcoal};
      text-decoration: none;
    }
  }
`;
const ContactMenuItem = ({ logo, title, info, url }) => {
  return (
    <WrapperContactMenuItem>
      <div className="logo-container">{logo}</div>
      <div className="contact-title-info">
        <div className="contact-title">{title}</div>
        <a href={url} className="info">
          {info}
        </a>
      </div>
    </WrapperContactMenuItem>
  );
};
